import { render } from "./home.vue?vue&type=template&id=3ffe7221"
const script = {}
script.render = render

export default script